import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface ShellPreferences {
  autoHideSideMenu: boolean;
  showNavMenuSearch: boolean;
  showNavExpandAll: boolean;
  showNavCollapseAll: boolean;
}

export interface ShellPreferencesStoreState extends ShellPreferences {
  setAutoHideSideMenu: (value: boolean) => void;
  setShowNavMenuSearch: (value: boolean) => void;
  setShowNavExpandAll: (value: boolean) => void;
  setShowNavCollapseAll: (value: boolean) => void;
}

export interface ShellPreferencesStoreOptions {
  storageKey: string;
}

export function createShellPreferencesStore(options: ShellPreferencesStoreOptions) {
  return create<ShellPreferencesStoreState>()(
    persist(
      (set) => ({
        autoHideSideMenu: false,
        showNavMenuSearch: false,
        showNavExpandAll: false,
        showNavCollapseAll: false,
        setAutoHideSideMenu: (value) => set({ autoHideSideMenu: value }),
        setShowNavMenuSearch: (value) => set({ showNavMenuSearch: value }),
        setShowNavExpandAll: (value) => set({ showNavExpandAll: value }),
        setShowNavCollapseAll: (value) => set({ showNavCollapseAll: value })
      }),
      {
        name: options.storageKey,
        partialize: (state) => ({
          autoHideSideMenu: state.autoHideSideMenu,
          showNavMenuSearch: state.showNavMenuSearch,
          showNavExpandAll: state.showNavExpandAll,
          showNavCollapseAll: state.showNavCollapseAll
        })
      }
    )
  );
}
